
import { Check } from '@educaplay/core/Icons/Check';
import classes from './CheckButton.module.scss';
import { useTranslate, useGameSounds } from "@educaplay/core";
import { useImperativeHandle, useRef } from 'react';
import { COMPLETAR_SOUNDS } from '../../utils/constants';

export const CheckButton = (props) => {
    const { onClick, ref } = props;
    const t = useTranslate();

    const gameSound = useGameSounds();
    const buttonRef = useRef();

    useImperativeHandle(ref, () => ({
        focus: () => {
            buttonRef.current.focus();
            gameSound.play(COMPLETAR_SOUNDS.HOVER_BUTTON)
        }
    }));

    return (
        <button
            type='button'
            ref={buttonRef}
            className={classes.button}
            onClick={onClick}
            onMouseEnter={() => gameSound.play(COMPLETAR_SOUNDS.HOVER_BUTTON)}
        >
            <span className={classes.icon}><Check /></span>
            <span className={classes.text}>{t("specific.check")}</span>
        </button>
    )
}